import React from "react";
import { BsX } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import Alerts from "../../etc/list/Alerts";
import ConstData from "../../../lib/ConstData";

const AlertErrorModal = ({ alertMessage, alertDetailMessage, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const handlePreventClick = (e) => {
        e.stopPropagation();
    }

    return (
        <div onClick={handlePreventClick}>
            <div className="d-flex justify-content-end w-100">
                <span className="func-btn" title={t("닫기", { ns: "common" })} onClick={() => handleSelectedFunc({ selectedFunc: "ALERT_ERROR_TOGGLE" })}>
                    <BsX />
                </span>
            </div>
            {/* 260804 기존 모달 스타일을 유지하며 서버 상세 오류를 안전한 텍스트로 표시 ... by hjkim */}
            <Alerts
                kind={ConstData.ALERT_KIND.DANGER}
                message={alertMessage}
                detailMessage={alertDetailMessage}
                isPlain={true}
                style={{ textAlign: "center", color: "white", fontSize: "80%", margin: "0.5rem 0" }}
            />
            <div className="d-flex justify-content-center my-2">
                <button type="button" className="btn btn-sm small red white-text m-0 mr-1 py-1 px-2" title={t("확인", { ns: "common" })} onClick={() => handleSelectedFunc({ selectedFunc: "ALERT_ERROR_TOGGLE" })}>
                    {t("확인", { ns: "common" })}
                </button>
            </div>
        </div>
    );
}

export default AlertErrorModal;
